var map = {
	"./ion-action-sheet-ios.entry.js": [
		118,
		67
	],
	"./ion-action-sheet-md.entry.js": [
		119,
		68
	],
	"./ion-alert-ios.entry.js": [
		120,
		59
	],
	"./ion-alert-md.entry.js": [
		121,
		60
	],
	"./ion-app_8-ios.entry.js": [
		122,
		53
	],
	"./ion-app_8-md.entry.js": [
		123,
		54
	],
	"./ion-avatar_3-ios.entry.js": [
		124,
		8
	],
	"./ion-avatar_3-md.entry.js": [
		125,
		9
	],
	"./ion-back-button-ios.entry.js": [
		126,
		10
	],
	"./ion-back-button-md.entry.js": [
		127,
		11
	],
	"./ion-backdrop-ios.entry.js": [
		128,
		12
	],
	"./ion-backdrop-md.entry.js": [
		129,
		13
	],
	"./ion-button_2-ios.entry.js": [
		130,
		69
	],
	"./ion-button_2-md.entry.js": [
		131,
		70
	],
	"./ion-card_5-ios.entry.js": [
		132,
		14
	],
	"./ion-card_5-md.entry.js": [
		133,
		15
	],
	"./ion-checkbox-ios.entry.js": [
		134,
		16
	],
	"./ion-checkbox-md.entry.js": [
		135,
		17
	],
	"./ion-chip-ios.entry.js": [
		136,
		18
	],
	"./ion-chip-md.entry.js": [
		137,
		19
	],
	"./ion-col_3.entry.js": [
		138,
		20
	],
	"./ion-datetime_3-ios.entry.js": [
		139,
		57
	],
	"./ion-datetime_3-md.entry.js": [
		140,
		58
	],
	"./ion-fab_3-ios.entry.js": [
		141,
		21
	],
	"./ion-fab_3-md.entry.js": [
		142,
		22
	],
	"./ion-img.entry.js": [
		143,
		23
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		144,
		24
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		145,
		25
	],
	"./ion-input-ios.entry.js": [
		146,
		26
	],
	"./ion-input-md.entry.js": [
		147,
		27
	],
	"./ion-item-option_3-ios.entry.js": [
		148,
		71
	],
	"./ion-item-option_3-md.entry.js": [
		149,
		72
	],
	"./ion-item_8-ios.entry.js": [
		150,
		73
	],
	"./ion-item_8-md.entry.js": [
		151,
		74
	],
	"./ion-loading-ios.entry.js": [
		152,
		28
	],
	"./ion-loading-md.entry.js": [
		153,
		29
	],
	"./ion-menu_3-ios.entry.js": [
		154,
		75
	],
	"./ion-menu_3-md.entry.js": [
		155,
		76
	],
	"./ion-modal-ios.entry.js": [
		156,
		55
	],
	"./ion-modal-md.entry.js": [
		157,
		56
	],
	"./ion-nav_2.entry.js": [
		158,
		66
	],
	"./ion-popover-ios.entry.js": [
		159,
		30
	],
	"./ion-popover-md.entry.js": [
		160,
		31
	],
	"./ion-progress-bar-ios.entry.js": [
		161,
		32
	],
	"./ion-progress-bar-md.entry.js": [
		162,
		33
	],
	"./ion-radio_2-ios.entry.js": [
		163,
		34
	],
	"./ion-radio_2-md.entry.js": [
		164,
		35
	],
	"./ion-range-ios.entry.js": [
		165,
		77
	],
	"./ion-range-md.entry.js": [
		166,
		78
	],
	"./ion-refresher_2-ios.entry.js": [
		167,
		61
	],
	"./ion-refresher_2-md.entry.js": [
		168,
		62
	],
	"./ion-reorder_2-ios.entry.js": [
		169,
		36
	],
	"./ion-reorder_2-md.entry.js": [
		170,
		37
	],
	"./ion-ripple-effect.entry.js": [
		171,
		38
	],
	"./ion-route_4.entry.js": [
		172,
		79
	],
	"./ion-searchbar-ios.entry.js": [
		173,
		80
	],
	"./ion-searchbar-md.entry.js": [
		174,
		81
	],
	"./ion-segment_2-ios.entry.js": [
		175,
		82
	],
	"./ion-segment_2-md.entry.js": [
		176,
		83
	],
	"./ion-select_3-ios.entry.js": [
		177,
		84
	],
	"./ion-select_3-md.entry.js": [
		178,
		85
	],
	"./ion-slide_2-ios.entry.js": [
		179,
		86
	],
	"./ion-slide_2-md.entry.js": [
		180,
		87
	],
	"./ion-spinner.entry.js": [
		181,
		39
	],
	"./ion-split-pane-ios.entry.js": [
		182,
		40
	],
	"./ion-split-pane-md.entry.js": [
		183,
		41
	],
	"./ion-tab-bar_2-ios.entry.js": [
		184,
		42
	],
	"./ion-tab-bar_2-md.entry.js": [
		185,
		43
	],
	"./ion-tab_2.entry.js": [
		186,
		44
	],
	"./ion-text.entry.js": [
		187,
		45
	],
	"./ion-textarea-ios.entry.js": [
		188,
		46
	],
	"./ion-textarea-md.entry.js": [
		189,
		47
	],
	"./ion-toast-ios.entry.js": [
		190,
		63
	],
	"./ion-toast-md.entry.js": [
		191,
		64
	],
	"./ion-toggle-ios.entry.js": [
		192,
		48
	],
	"./ion-toggle-md.entry.js": [
		193,
		49
	],
	"./ion-virtual-scroll.entry.js": [
		194,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 92;
module.exports = webpackAsyncContext;